import app from "flarum/common/app";
import Modal from "flarum/common/components/Modal";
import Button from "flarum/common/components/Button";
import Select from "flarum/common/components/Select";
import Stream from "flarum/common/utils/Stream";
import extractText from "flarum/common/utils/extractText";
import { getConfiguredTiers, DEFAULT_TIER_ID } from "../utils/tiers";
const trans = key => app.translator.trans(`ramon-verified.lib.verification_prompt.${key}`);

/**
 * Coleta uma nota de auditoria e, opcionalmente, o tier — substitui os
 * `window.prompt` dos fluxos de verify/approve/revoke por uma UI consistente
 * com o resto da extensão. Resolve a promise do caller via `attrs.resolve`:
 * o resultado no confirm, `null` em qualquer cancelamento (X, Esc, backdrop).
 */
export default class VerificationPromptModal extends Modal {
  tiers = [];
  settled = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.note = Stream("");
    this.tiers = this.attrs.withTier ? getConfiguredTiers() : [];
    const fallback = this.tiers.find(t => t.id === DEFAULT_TIER_ID) || this.tiers[0];
    this.tierId = Stream(fallback ? fallback.id : "");
  }
  className() {
    return "VerificationPromptModal Modal--small";
  }
  title() {
    return this.attrs.promptTitle;
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, this.tiers.length > 1 ? this.tierField() : null, m("div", {
      className: "Form-group"
    }, m("label", null, this.attrs.noteLabel), m("textarea", {
      className: "FormControl",
      rows: 3,
      maxlength: 1000,
      placeholder: extractText(trans("note_placeholder")),
      bidi: this.note
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => this.confirm()
    }, this.attrs.confirmLabel)));
  }
  tierField() {
    const options = {};
    this.tiers.forEach(t => {
      options[t.id] = t.label;
    });
    return m("div", {
      className: "Form-group"
    }, m("label", null, trans("tier_label")), m(Select, {
      value: this.tierId(),
      options: options,
      onchange: v => this.tierId(v)
    }));
  }
  confirm() {
    this.settle({
      tier: this.attrs.withTier ? this.tierId() : null,
      note: this.note().trim()
    });
    this.hide();
  }

  /**
   * Todo caminho de dismissal (X, Esc, clique no backdrop) remove o vnode e
   * cai aqui — quando o modal não foi confirmado, o caller recebe `null`.
   */
  onremove(_vnode) {
    this.settle(null);
  }
  settle(result) {
    if (this.settled) return;
    this.settled = true;
    this.attrs.resolve(result);
  }
}
flarum.reg.add('ramon-verified', 'common/components/VerificationPromptModal', VerificationPromptModal);